import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectCommitDiffModule } from '@portal-core/commits/components/project-commit-diff/project-commit-diff.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { ProjectFilesAIDialogComponent } from '@portal-core/project-files/components/project-files-ai-dialog/project-files-ai-dialog.component';
import { DiffPipeModule } from '@portal-core/project-files/pipes/diff/diff.module';
import { FlareCodePipeModule } from '@portal-core/project-files/pipes/flare-code/flare-code.module';
import { MarkdownToFlareXMLModule } from '@portal-core/project-files/pipes/markdown-to-flare-xml/markdown-to-flare-xml.module';
import { NormalizeFlareXMLModule } from '@portal-core/project-files/pipes/normalize-flare-xml/normalize-flare-xml.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [
    ProjectFilesAIDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    DiffPipeModule,
    ErrorsExpansionPanelModule,
    FlareCodePipeModule,
    FlareTextEditorModule,
    FormsModule,
    MarkdownToFlareXMLModule,
    MatProgressBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    NormalizeFlareXMLModule,
    ProjectCommitDiffModule,
    ReactiveFormsModule,
    SwitchBoardModule
  ],
  exports: [
    ProjectFilesAIDialogComponent
  ]
})
export class ProjectFilesAIDialogModule { }
